import { useState, useEffect } from 'react';
import { Flex, Stack, useToast } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { updateOrgProfile, updateOrgProfileReset } from '../../../organizations/actions/organizations-actions';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import LaunchdeckModalButtonBar from '../../../global/components/helper-components/components/LaunchdeckModalButtonBar';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import { getAdminOrgProfile } from '../../actions/admin-user-actions';


function EditOrgBillingForm({ orgProfile, handleCloseModal, manageAdminOrgProfileOutcome, isMobileView,
	// Actions
	getAdminOrgProfile,
	updateOrgProfile,
	updateOrgProfileReset

 }) {

	const toast = useToast();

	const { orgId, orgRegisteredCountry, orgRegisteredAddress, orgRegisteredName, orgRegisteredNumber } = orgProfile || {}
	const [editingInProgress, setEditingInProgress] = useState(false);

	// Inputs
	const [orgRegisteredNameDisplay, setOrgRegisteredNameDisplay] = useState(orgRegisteredName)
	const [orgRegisteredNumberDisplay, setOrgRegisteredNumberDisplay] = useState(orgRegisteredNumber)
	const [orgRegisteredCountryDisplay, setOrgRegisteredCountryDisplay] = useState(orgRegisteredCountry)
	const [orgRegisteredAddressDisplay, setOrgRegisteredAddressDisplay] = useState(orgRegisteredAddress)


	// UX & State Management
	useEffect(() => {
		if (manageAdminOrgProfileOutcome) {
			const { updatedSuccessfully, errorMessage } = manageAdminOrgProfileOutcome || {};

			const closeModalAndReset = () => {
				setEditingInProgress(false)
				handleCloseModal()
				updateOrgProfileReset()
			}

			if (updatedSuccessfully === true) {
				getAdminOrgProfile()

				toast(
					triggerLaunchdeckToast({
						useCase: "show-success-state",
						// bannerText: "",
						label: "Your organization info has been updated",
						isMobileView
					})
				)

				closeModalAndReset()
			}

			if (updatedSuccessfully === false) {
				if (errorMessage) {

					toast(
						triggerLaunchdeckToast({
							useCase: "show-error-state",
							bannerText: "Error",
							label: errorMessage,
							isMobileView
						})
					)

					closeModalAndReset()
				}
			}
		}
	}, [manageAdminOrgProfileOutcome, handleCloseModal, toast]);

	// Component functionality
	const handleChange = (event) => {
		const value = event.target.value;
		const variableName = event.target.name;
		switch (variableName) {
			case ('orgRegisteredName'): {
				setOrgRegisteredNameDisplay(value)
				break;
			}
			case ('orgRegisteredCountry'): {
				setOrgRegisteredCountryDisplay(value)
				break;
			}
			case ('orgRegisteredAddress'): {
				setOrgRegisteredAddressDisplay(value)
				break;
			}
			case ('orgRegisteredNumber'): {
				setOrgRegisteredNumberDisplay(value)
				break;
			}
			default: {
				console.log('There is no variable with this name', variableName)
				break;
			}
		}
	}

	const handleSubmitEditProfile = () => {
		setEditingInProgress(true)

		let updateOrgUserProperties = {
			orgRegisteredName: orgRegisteredNameDisplay ? orgRegisteredNameDisplay.trim() : "",
			orgRegisteredCountry: orgRegisteredCountryDisplay && orgRegisteredCountryDisplay.trim(),
			orgRegisteredAddress: orgRegisteredAddressDisplay ? orgRegisteredAddressDisplay.trim() : "",
			orgRegisteredNumber: orgRegisteredNumberDisplay ? orgRegisteredNumberDisplay.trim() : ""
		}

		updateOrgProfile(updateOrgUserProperties, orgId, 'edit-org-billing-details')
	}


	return (
		<Flex align='center' w='100%' maxW={['inherit', '35em']} direction='column' overflowY='auto' maxHeight='80vh' >
			<Stack w='100%' px='2em' py='1em' gap='1.5em'>

				<LaunchdeckFormInput
					label='Legal Entity Name'
					name={'orgRegisteredName'}
					onChange={handleChange}
					value={orgRegisteredNameDisplay}
				/>

				<LaunchdeckFormInput
					label='Registered Address'
					name={'orgRegisteredAddress'}
					onChange={handleChange}
					value={orgRegisteredAddressDisplay}
				/>

				<LaunchdeckFormInput
					label='Incorporated In'
					name={'orgRegisteredCountry'}
					onChange={handleChange}
					value={orgRegisteredCountryDisplay}
				/>

				<LaunchdeckFormInput
					label='Business Registration Number'
					name={'orgRegisteredNumber'}
					onChange={handleChange}
					value={orgRegisteredNumberDisplay}
				/>
			</Stack>

			<LaunchdeckModalButtonBar
				fontSize='1em'
				handleCloseModal={handleCloseModal}
				loadingLogic={editingInProgress}
				ctaFunction={() => handleSubmitEditProfile()}
				ctaLabel='Save Changes'
				cancelLabel='Cancel'
			/>
		</Flex>
	);
}

function mapStateToProps(state) {
	return {
		manageAdminOrgProfileOutcome: state.manageAdminOrgProfileOutcome.results.data,
		isMobileView: state.mobileViewMode.isMobileView
	};
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
			getAdminOrgProfile,
      updateOrgProfile,
			updateOrgProfileReset
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditOrgBillingForm));